import * as Types from '../graphql.generated';

export type Saved_Search_And_Alerts_FragmentFragment = {
    __typename?: 'SavedSearchAndAlerts';
} & Pick<Types.SavedSearchAndAlerts, 'uri'> & {
        currentFrequency?: Types.Maybe<
            { __typename?: 'AlertFrequencyOption' } & Pick<
                Types.AlertFrequencyOption,
                'i18NLabelKey' | 'value'
            >
        >;
    };

export const Saved_Search_And_Alerts_FragmentFragmentDoc = `
    fragment SAVED_SEARCH_AND_ALERTS_FRAGMENT on SavedSearchAndAlerts {
  uri
  currentFrequency {
    i18NLabelKey
    value
  }
}
    `;
export type Requester<C = {}, E = unknown> = <R, V>(
    doc: string,
    vars?: V,
    options?: C
) => Promise<R>;
export function getSdk<C, E>(requester: Requester<C, E>) {
    return {};
}
export type Sdk = ReturnType<typeof getSdk>;
